import PersonAdd from "@mui/icons-material/PersonAdd";
import {
  Alert,
  Box,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { SignersDatagrid } from "components/Submission/SignersDatagrid";
import { Issue, SignatureType } from "generated-graphql/graphql";
import { SubmissionReviewerSigner } from "hooks/useSubmissionForm";
import { DateTime } from "luxon";

export function SignatureConfigSection({
  disabled,
  signatureType,
  onSignatureTypeChange,
  onAddSigner,
  signer,
  onRemoveSigner,
  submissionDueDate,
  signatureTypeIssues,
}: {
  disabled: boolean;
  signatureType: SignatureType;
  onSignatureTypeChange: (next: SignatureType) => void;
  onAddSigner: () => void;
  signer: SubmissionReviewerSigner | null;
  onRemoveSigner: () => void;
  submissionDueDate: DateTime | undefined;
  signatureTypeIssues: Issue[];
}) {
  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1" fontWeight="medium">
          Signature
        </Typography>
        <Tooltip title="Add signer">
          <span>
            <IconButton
              size="small"
              aria-label="Add signer"
              onClick={onAddSigner}
              disabled={disabled || signatureType === SignatureType.None}
              sx={{
                color:
                  !disabled && signatureType !== SignatureType.None ? "primary.main" : "inherit",
              }}
            >
              <PersonAdd fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>
      <RadioGroup
        row
        value={signatureType}
        onChange={(e) => {
          const next = Object.values(SignatureType).find((t) => t === e.target.value);
          if (next) onSignatureTypeChange(next);
        }}
      >
        <FormControlLabel
          value={SignatureType.None}
          disabled={disabled}
          control={<Radio size="small" disabled={disabled} />}
          label={<Typography variant="body2">No signature</Typography>}
        />
        <FormControlLabel
          value={SignatureType.Digital}
          disabled={disabled}
          control={<Radio size="small" disabled={disabled} />}
          label={<Typography variant="body2">Digital signature</Typography>}
        />
        <FormControlLabel
          value={SignatureType.WetInk}
          disabled={disabled}
          control={<Radio size="small" disabled={disabled} />}
          label={<Typography variant="body2">Wet-ink signature</Typography>}
        />
      </RadioGroup>
      {signatureType !== SignatureType.None && (
        <SignersDatagrid
          signers={signer ? [signer] : []}
          signatureType={signatureType}
          handleAddSigner={onAddSigner}
          handleRemoveSigner={onRemoveSigner}
          submissionDueDate={submissionDueDate}
          disabled={disabled}
        />
      )}
      {signatureTypeIssues.length > 0 && (
        <Alert severity="error" sx={{ mt: 1, mb: 1 }}>
          {signatureTypeIssues.map((i, index) => (
            <div key={index}>{i.message}</div>
          ))}
        </Alert>
      )}
    </Box>
  );
}
